var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"div-flex-center",attrs:{"id":"document"}},[_c('div',{staticClass:"left div-flex-column-center"},_vm._l((_vm.menus),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.auth == '1'),expression:"item.auth == '1'"}],key:index,class:{
        menu: true,
        'div-flex-center': true,
        'is-active': _vm.isActive == item.name,
      },on:{"click":function($event){return _vm.jump(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0),_c('div',{staticClass:"right"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }